export default "__VITE_ASSET__9t0_MFMA__"